module.exports = __webpack_public_path__ + "img/SENTBIZ_logo_black.539f7277.png";